import React from "react";
import PatientAppointmentTable from "../../../components/patient-side-components/patient-appointment-table/PatientAppointmentTable";

const PatientAppointment = () => {
  return (
    <div className="flex w-full items-center justify-center flex-col relative">
      <PatientAppointmentTable />
    </div>
  );
};

export default PatientAppointment;
